import http from '~/http/services/pos';
import { ApiResponse } from '~/types/Api';
import { MenuAndCategory } from '~/types/Menu';
import { OrderTypeResponseData } from '~/types/OrderType';

const MENU_AND_CATEGORY_URL = '/api/v1/menu?isActive=true';
const ORDER_TYPE_URL = '/api/v1/orderType';

type MenuAndCategoryResponse = ApiResponse<MenuAndCategory[]>;
type OrderTypeResponse = ApiResponse<OrderTypeResponseData>;

export const fetchMenu = () => {
  return http.get<MenuAndCategoryResponse>(MENU_AND_CATEGORY_URL);
};

export const fetchOrderType = () => {
  return http.get<OrderTypeResponse>(ORDER_TYPE_URL);
};
